import styled from 'styled-components';
import { Header4, Header5 } from 'library/styles/text';
import { ButtonBack } from 'library/styles/button';
import { ActionIconListItem } from 'library/styles/icon';
import Colors from 'library/constants/colors';
import { Row as GridRow } from 'library/components/view-mode/grid/styles';
import { Container as Color } from 'library/components/color/styles';
import { ShadowSlight } from 'library/constants/styles-config';
import { OverlayImage, ImageContainer as SliderImageContainer } from 'library/components/slider/styles';
import ColorComponent from 'library/components/color';
import { Container as GridContainer } from 'library/components/grid-items-container/styles';

export const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: calc(100vh - 124px);
`;

export const RowContainer = styled.div`
  opacity: ${({ isLoaded }) => (isLoaded ? 1 : 0)};
  transition: opacity 0.5s ease-out;
`;

export const Row = styled(GridRow)`
  display: flex;
  flex-wrap: wrap;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  max-width: 1264px;


  ${GridContainer} {
    margin: 20px 0;
  }
`;

export const RowColors = styled(Row)`
  box-sizing: border-box;
  flex-wrap: wrap;
  padding: 12px;
  
  ${Color} {
    margin-right: 24px;
    margin-bottom: 24px;
    box-shadow: ${ShadowSlight};
  }
`;

export const RowHeader = styled.div`
  width: 100%;
  max-width: 1264px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 12px;
  margin-top: 25px;
  border-bottom: 1px solid ${Colors.shade06};

  
  ${Header5} {
    margin-bottom: 6px;
  }
`;

export const Image = styled.div`
  box-sizing: border-box;
  width: 184px;
  padding: 12px;
  overflow: hidden;
  
  ${SliderImageContainer} {
    box-shadow: ${ShadowSlight};
    border-radius: 8px;
    height: 100%;
    min-height: min-content;
  }
  
  img {
    //display: block;
    //max-width: 100%;
    position: relative;
    width: 100%;
    border-radius: 8px;
    filter: drop-shadow(0px 2px 8px rgba(45, 49, 50, 0.16));
  }
`;

export const RowImages = styled(Row)`
  margin-bottom: 12px;
`;

export const ImageContainer = styled(SliderImageContainer)`
  ${({ isSelected }) => isSelected && `    
    ${OverlayImage} {
      opacity: 0.7;
      background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
    }
    
    i.icon-check-inverse {
      color: ${Colors.shade05};      
    }
  `}
`;

export const StyledColor = styled(ColorComponent)`
  ${({ isSelected }) => isSelected && `    
    opacity: 0.8;
      background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
    
    i.icon-check-inverse {
      color: ${Colors.shade02};      
    }
  `}
`;

export const Meta = styled.div`
  display: flex;
  align-items: center;
  width: calc(100% - 120px);
  
  ${ButtonBack} {
    width: auto;
    margin-right: 20px;
  }
`;

export const Header = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  padding: 24px 40px;
  background: linear-gradient(180deg, ${Colors.shade06} 0%, ${Colors.shade07} 100%);
  transition: padding-right 0.4s;
  ${({ isShrunk }) => isShrunk && 'padding-right: 580px;'}
  
  ${Header4} {
    margin-bottom: 4px;
  }
`;

export const Actions = styled.div`
  box-sizing: border-box;
  display: flex;
`;

export const ActionIcon = styled(ActionIconListItem)`
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 540px;
  z-index: 20;
`;
